export default __webpack_public_path__ + "static/media/team-banner.bb6f8a21.webp";